module.exports = __webpack_public_path__ + "ab43045f8df2d77ca5f8adf52ee80fb0.svg";